/** The same per-image rule used by the card foil-map bake and dice artwork. */
export function foilLuminanceStats(luma) {
  let sum = 0;
  const hist = new Uint32Array(256);
  for (const value of luma) { sum += value; hist[Math.min(255, Math.max(0, value * 255 | 0))]++; }
  const percentile = (p) => {
    let count = 0;
    for (let b = 0; b < 256; b++) { count += hist[b]; if (count >= p * luma.length) return b / 255; }
    return 1;
  };
  return { mean: luma.length ? sum / luma.length : 0, spread: percentile(0.95) - percentile(0.05) };
}
export function classifyFoilLuminance(luma) {
  const { mean, spread } = foilLuminanceStats(luma);
  return mean < 0.30 ? 'DARK' : spread < 0.45 ? 'COLOUR' : 'LIGHT';
}
